import React from 'react'
import classname from 'classnames'

const Tabs = ({ children, addClass}) => {

	const additionalClass = classname({
		addClass,
		'tabs': true
	})

	return (
		<div className={additionalClass}>
			<div className="tabs__cols">
				{React.Children.map(children, child => (
					<div className="tabs__col">
						{child}
					</div>
				))}
			</div>
		</div>
	)
}

const Tab = ({ ['data-testid']: dataTestId, label, active, onClick, id="" }) => {

	const tabClass = classname({
		'tabs__item': true,
		'tabs__item--active': active,
	})

	return (
		<div className={tabClass} onClick={onClick} id={id} data-testid={dataTestId}>
			{label}
		</div>
	)
}

export default Tabs
export { Tab }
